import { React, useState, useEffect } from "react";
import "./Glossary.css";
import GlossaryItem from "./GlossaryItem";
import {
  getGlossary,
  getGlossaryLikes,
  addLikedGlossary,
  deleteLikedGlossary,
} from "../../../apis/glossaryApi";
import { useInvalidateQuery } from "../../InvalidateQueryContext";
import { glossaryApiKey } from "../../../apis/ApiKey/glossaryApiKey";
import deleteButton from "../../../assets/shapes_svg/glossary/blue_delete_button.svg";
import likeButton from "../../../assets/like-button.svg";
import GlossaryCard from "./GlossaryCard";

const GlossaryPage = () => {
  const [glossaryItems, setGlossaryItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [likedItems, setLikedItems] = useState([]);
  const [trackClick, setTrackClick] = useState(false);
  const [isActiveButton, setIsActiveButton] = useState("");
  const { invalidateKey, resetKey, triggerInvalidate } = useInvalidateQuery();
  const { createdLikedGlossary, removeLikedGlossary } = glossaryApiKey;

  useEffect(() => {
    getGlossary({ setGlossaries: setGlossaryItems });
    getGlossaryLikes({ setGlossaryLikes: setLikedItems });
  }, []);

  useEffect(() => {
    setFilteredItems(glossaryItems);
  }, [glossaryItems]);

  // Filter items by first letter
  const filterItems = (letter) => {
    const filtered = glossaryItems.filter((item) =>
      item.title.toLowerCase().startsWith(letter.toLowerCase())
    );
    setFilteredItems(filtered);
    setTrackClick(true);
    setIsActiveButton(letter);
  };

  // Show all items
  const handleShowAll = () => {
    setFilteredItems(glossaryItems);
    setTrackClick(false);
    setIsActiveButton("");
  };

  const handleClickItem = (item) => {
    setSelectedItem(item);
  };

  const handleAddToLikedItems = (glossary_id) => {
    addLikedGlossary({
      glossary_id: glossary_id,
      triggerInvalidate: triggerInvalidate,
    });
  };

  const handleRemoveFromLikedItems = (id) => {
    deleteLikedGlossary({ id: id, triggerInvalidate: triggerInvalidate });
  };

  useEffect(() => {
    if (
      invalidateKey === createdLikedGlossary ||
      invalidateKey === removeLikedGlossary
    ) {
      getGlossary({ setGlossaries: setGlossaryItems });
      getGlossaryLikes({ setGlossaryLikes: setLikedItems });
    }
    resetKey();
  }, [createdLikedGlossary, removeLikedGlossary, invalidateKey, resetKey]);

  const isItemLiked = (itemId) =>
    likedItems.some((likedItem) => likedItem.id === itemId);

  return (
    <div className="glossary-container">
      <div className="glossary">
        <div className="letter-filters">
          {/* Buttons for filtering */}
          <div className="button-container">
            {Array.from({ length: 26 }, (_, i) => (
              <button
                key={i}
                style={
                  isActiveButton === String.fromCharCode(65 + i)
                    ? {
                        transform: "translateY(6px)",
                        backgroundColor: "rgba(27, 55, 100, 0.8)",
                      }
                    : {}
                }
                onClick={() => {
                  if (!trackClick) {
                    filterItems(String.fromCharCode(65 + i));
                  } else {
                    handleShowAll();
                  }
                }}
              >
                {String.fromCharCode(65 + i)}
              </button>
            ))}
          </div>
        </div>
        <div className="item-list-container">
          <div className="item-list">
            {/* Render filtered glossary items */}
            {filteredItems &&
              filteredItems.length > 0 &&
              filteredItems.map((item) => (
                <div key={item.title}>
                  <GlossaryItem
                    title={item.title}
                    description={item.description.substring(0, 100) + "..."}
                    onClick={() => handleClickItem(item)}
                    onClickLike={() =>
                      isItemLiked(item.id)
                        ? handleRemoveFromLikedItems(item.id)
                        : handleAddToLikedItems(item.id)
                    }
                    isLiked={isItemLiked(item.id)}
                  />
                </div>
              ))}
          </div>
        </div>
        <div className="full-description">
          <button
            className="like-button"
            onClick={() =>
              isItemLiked(selectedItem.id)
                ? handleRemoveFromLikedItems(selectedItem.id)
                : handleAddToLikedItems(selectedItem.id)
            }
            style={{
              opacity:
                selectedItem && isItemLiked(selectedItem.id) ? "1" : "0.5",
            }}
          ></button>
          <h2 className="full-description-title">Selected</h2>
          {/* Render full description */}
          {selectedItem && (
            <div className="description-item">
              <div className="description-item-title">
                <h2>{selectedItem.title}</h2>
              </div>

              <p>{selectedItem.description}</p>
            </div>
          )}
        </div>
        <div className="liked-items">
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <GlossaryCard />
            <ul style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
              {likedItems &&
                likedItems.length > 0 &&
                likedItems.map((item, index) => (
                  <div style={{ position: "relative" }}>
                    <li key={index} onClick={() => handleClickItem(item)}>
                      {item.title}
                    </li>
                    <div
                      style={{ position: "absolute", left: "12%", top: "3%" }}
                    >
                      <img
                        src={likeButton}
                        alt="Like Glossary Button"
                        width={22}
                        height={22}
                      />
                    </div>
                    <div
                      style={{ position: "absolute", right: "-6%", top: "3%" }}
                    >
                      <img
                        src={deleteButton}
                        alt="Delete Glossary Button"
                        onClick={() => handleRemoveFromLikedItems(item.id)}
                        width={22}
                        height={22}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlossaryPage;
